import React from "react";
import { createBrowserRouter } from "react-router-dom";

import Error from "../../pages/public/Error";

import MyTasks from "../../pages/staff/MyTasks2";

//--------Admin-------
import { AuthProtected } from "../AuthProtectedOutlet";
import { AdminProtected } from "../AdminProtectedOutlet";
import { mainRoutes } from "./mainRoutes";
import { adminProtectedRoutes } from "./adminProtectedRoutes";
import { vendorRoutes } from "./vendorRoutes";
import { PublicRoutes } from "./PublicRoutes";
import { GlobalOutlet, Layout } from "../GlobalOutlet";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <GlobalOutlet />,
    children: [
      ...PublicRoutes,
      {
        path: "/",
        element: <Layout />,
        children: [
          ...mainRoutes,
          {
            path: "",
            element: <AuthProtected />,
            children: [
              {
                path: "/mytasks",
                element: <MyTasks />,
              },
              {
                path: "",
                element: <AdminProtected />,
                children: [...adminProtectedRoutes],
              },
            ],
          },
        ],
        errorElement: <Error error="404 page not found" />,
      },
    ],
  },

  ...vendorRoutes,
]);
